export default __webpack_public_path__ + "static/media/P00138022_WF_BRAND_FY25_ISF_AprUpdate20_LP_1164x584.af24c760.jpg";